var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondlevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6713 8.93367L16.7395 26.7854L0.807617 8.93367L9.3863 0.0078125H24.0926L32.6713 8.93367Z",
    fill: "#38ACFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0926 0.0078125L32.6713 8.93367H0.807617L9.3863 0.0078125H24.0926Z",
    fill: "#6CC1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6711 8.93367L16.7393 26.7854V0.0078125H24.0924L32.6711 8.93367Z",
    fill: "#2080F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6711 8.93367H16.7393V0.0078125H24.0924L32.6711 8.93367Z",
    fill: "#3A99F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.80742 8.93367L16.7393 26.7854L8.56908 8.93367L16.7393 0.0078125H9.3861L0.80742 8.93367Z",
    fill: "#3A99F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79461 0.0078125L0.80742 8.93367H8.56908L16.7393 0.0078125H9.79461Z",
    fill: "#75CDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.328556 9.00195L16.6587 27.002L3.25961 9.00195L12.2493 0.00195345H9.1217L0.328556 9.00195Z",
    fill: "#BCDBFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38555 0.0078125L0.746057 9.03594H3.27731L12.2451 0.0078125H9.38555Z",
    fill: "#D8F1FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6711 8.93367L16.7393 26.7854L24.9094 8.93367L16.7393 0.0078125H24.0924L32.6711 8.93367Z",
    fill: "#08459A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0924 0.0078125L32.6711 8.93367H24.9094L16.7393 0.0078125H24.0924Z",
    fill: "#61B3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6711 8.93367L16.7393 26.7854L29.8115 8.93367L21.2329 0.0078125H24.0924L32.6711 8.93367Z",
    fill: "#0769DD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0925 0.0078125L32.6712 8.93367H29.8116L21.2329 0.0078125H24.0925Z",
    fill: "#388AFD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99694 2.30679C8.16842 2.44006 8.18857 2.6748 8.04194 2.8311L2.77233 8.4485C2.62571 8.60479 2.36784 8.62346 2.19637 8.49019C2.0249 8.35692 2.00475 8.12218 2.15137 7.96588L7.42098 2.34848C7.5676 2.19218 7.82547 2.17352 7.99694 2.30679Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7197 2.27024C15.8929 2.40133 15.916 2.6358 15.7713 2.79393L10.5731 8.47744C10.4284 8.63557 10.1708 8.65749 9.99769 8.5264C9.82455 8.3953 9.80144 8.16084 9.94607 8.0027L15.1443 2.3192C15.289 2.16106 15.5466 2.13914 15.7197 2.27024Z",
    fill: "#A2D8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondlevel);
export default __webpack_public_path__ + "static/media/diamondlevel.612e40ed2232f92d77e218175b852aff.svg";
export { ForwardRef as ReactComponent };